import React, { useState } from 'react';
import Module from "../common/moduleTitle";
import Schedule from "../common/schedule";
import fh from "../../../images/aiReport/fh.png";

const ResultApp = (props) => {
    const { personalityResults = [], } = props.data;
    const newVersion = true;

    if(personalityResults && personalityResults.length > 0){
        return (
            <div className="competency-wrap personality-wrap">
                <div className="readingTitleWrap">
                    <div className="readingTitleLeft">
                        <div className="readingTitleLeftIcon">
                            <span></span>
                            <span></span>
                        </div>
                        <span>大五人格</span>
                    </div>
                    <div className="readingTitleRight">

                    </div>
                </div>
                {/*内容部分*/}
                {
                    (
                        personalityResults.map((item,key) => {
                            if(newVersion){
                                return (
                                    <div className="result-padding" key={`ability${key}`}>
                                        <div className="result-evaluate result-evaluate-personality" style={{marginTop: key ? 16 : 24}}>
                                            <div className='result-personality-left'>
                                                <div className='result-personality-left-name'>{item.name || ''}</div>
                                                <div className='result-personality-left-schedule'>
                                                    <div className={`result-personality-item ${item.grade == 1 ? 'active' : ''}`}>
                                                        <i></i><span>{item.lowGradeFeature}</span>
                                                    </div>
                                                    <div className={`result-personality-item ${item.grade == 2 ? 'active' : ''}`}>
                                                        <i></i><span></span>
                                                    </div>
                                                    <div className={`result-personality-item ${item.grade == 3 ? 'active' : ''}`}>
                                                        <i></i><span>{item.highGradeFeature}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="result-evaluate-cont">{item.evaluate}</div>
                                        </div>
                                    </div>
                                )
                            }
                            return (
                                <div className="result-padding" key={`ability${key}`}>
                                    <Module
                                        text={item.name || ''}
                                        enText={"OCEAN"}
                                    />
                                    <Schedule
                                        active={item.grade || 0}
                                        rangeMin={0}
                                        rangeMax={0}
                                        scaleNum={3}
                                        isScale={false}
                                        intervalResult={[item.lowGradeFeature, item.highGradeFeature]}
                                    />
                                    {item.evaluate && <div className="result-evaluate" style={{marginTop: 24}}>
                                        <img src={fh} className="result-evaluate-d"/>
                                        <div className="result-evaluate-tit">人格分析</div>
                                        <div className="result-evaluate-cont">{item.evaluate}</div>
                                    </div>}
                                </div>
                            )
                        })
                    )
                }

            </div>
        );
    } else {
        return null;
    }
}

export default ResultApp;
